import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { SWRConfig } from "swr";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import AccountProvider from "./context/AccountProvider";
import ArrangementProvider from "./context/ArrangementProvider";
import AuthProvider from "./context/AuthProvider";
import SfsProvider from "./context/SfsProvider";
import ClientProvider from "./context/ClientProvider";
import CookieProvider from "./context/CookieProvider";
import NavProvider from "./context/NavProvider";
import PartyProvider from "./context/PartyProvider";
import UtilsProvider from "./context/UtilsProvider";
import ProfileProvider from "./context/ProfileProvider";
import CallMeProvider from "./context/CallMeProvider";
import DocumentsProvider from "./context/DocumentsProvider";
import NotificationsProvider from "./context/NotificationsProvider";
import AccessibilityProvider from "./context/AccessibilityProvider";
import { AnalyticsProvider } from "./context/AnalyticsProvider";

import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

// Features financial statement
import { SlimFinancialProvider } from "./features/financial-statement/context/SlimFinancialProvider";

// Common fetcher function for SWR usage
const fetcher = ([url, options]) =>
    fetch(url, options).then((res) => res.json());

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            retry: 2,
            refetchOnWindowFocus: false,
        },
    },
});

root.render(
    <QueryClientProvider client={queryClient}>
        <SWRConfig value={{ fetcher: fetcher }}>
            <UtilsProvider>
                <ClientProvider>
                    <AuthProvider>
                        <CookieProvider>
                            <ProfileProvider>
                                <NotificationsProvider>
                                    <AccountProvider>
                                        <PartyProvider>
                                            <SfsProvider>
                                                <SlimFinancialProvider>
                                                    <ArrangementProvider>
                                                        <NavProvider>
                                                            <CallMeProvider>
                                                                <AccessibilityProvider>
                                                                    <DocumentsProvider>
                                                                        <AnalyticsProvider>
                                                                                <App />
                                                                        </AnalyticsProvider>
                                                                    </DocumentsProvider>
                                                                </AccessibilityProvider>
                                                            </CallMeProvider>
                                                        </NavProvider>
                                                    </ArrangementProvider>
                                                </SlimFinancialProvider>
                                            </SfsProvider>
                                        </PartyProvider>
                                    </AccountProvider>
                                </NotificationsProvider>
                            </ProfileProvider>
                        </CookieProvider>
                    </AuthProvider>
                </ClientProvider>
            </UtilsProvider>
        </SWRConfig>
    </QueryClientProvider>,
);
